import React, {useState , useEffect} from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import p1 from '../assets/images/payment-icon/1.png';
import p2 from '../assets/images/payment-icon/2.png';
import p3 from '../assets/images/payment-icon/3.png';
import p4 from '../assets/images/payment-icon/4.png';
import p5 from '../assets/images/payment-icon/5.png';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import StripeCheckout from "react-stripe-checkout"
import axios from "axios"
import logo1 from '../assets/images/logo1.png';


import {loadStripe} from '@stripe/stripe-js';




// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";










const Checkout = (props) => {
    const [fname , setfName ] = useState("")
    const [Lname , setLName ] = useState("")
    const [Address , setAddress ] = useState("")
    const [Address1 , setAddress1 ] = useState("")
    const [Country , setCountry ] = useState("")
    const [ZipPostal , setZipPostal ] = useState("1")
    const [Email , setEmail ] = useState("")
    const [Phone , setPhone ] = useState("")
    const [DIFFERENTfname , setDIFFERENTfName ] = useState("")
    const [DIFFERENTLname , setDIFFERENTLName ] = useState("")
    const [DIFFERENTAddress , setDIFFERENTAddress ] = useState("")
    const [DIFFERENTAddress1 , setDIFFERENTAddress1 ] = useState("")
    const [DIFFERENTZipPostal , setDIFFERENTZipPostal ] = useState("")
    const [DIFFERENTEmail , setDIFFERENTEmail ] = useState("")
    const [DIFFERENTPhone , setDIFFERENTPhone ] = useState("")
    const [admindataall , setadmindataall ] = useState(0)
    const [promo , setpromo] = useState("")

    const [MainCatogories , setMainCatogories] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    const [SubClassCategories , setSubClassCategories] = useState([])

    const [photo1 , setphoto1 ] = useState("")
    const [discount , setdiscount ] = useState({})
    const [photo2 , setphoto2 ] = useState("")

    const [Order_Notes , setOrder_Notes ] = useState("")
    const [City , setCity ] = useState("")
    const [DIFFERENTOrder_Notes , setDIFFERENTOrder_Notes ] = useState("")
    const [DIFFERENTCity , setDIFFERENTCity ] = useState("")
    const [paymenttype , setpaymenttype ] = useState("")
    const [cart , setCart] = useState([])
    const [tot , setot] = useState(0)
    const [total , settotal] = useState(0)
    const [doctor , setdoctor] = useState(0)

    const [display , setdisplay] = useState(true)
    const [play , setplay] = useState(false)
    const [customPhotojson , setcustomPhotojson] = useState(false)
    const [Num1111 , setNum1111] = useState(0)
    const [SubPeice , setSubPeice] = useState(0)
    const [Num11 , setNum11] = useState(0)
    const [SubTotal , setSubTotal] = useState(0)
    const [chack, setchack] = useState(false) 
    const [chack1, setchack1] = useState(false) 
    const [paymenttype3, setpaymenttype3] = useState(false) 
    const [Cate1 , setCate1] = useState([])
    const [Cate2 , setCate2] = useState([])
    // const [Product_Image_Upload , setProduct_Image_Upload] = useState("")

//  const [stripePromise, setStripePromise] = useState(null);
//   const [clientSecret, setClientSecret] = useState("");



    useEffect(() =>{
        window.scrollTo(0, 0)
        // document.getElementById("c").style.display = "none"
        var data =  JSON.parse(localStorage.getItem("Cart")) 
        // var data1 =  JSON.parse(localStorage.getItem("CartPrice")) 
        if (data) {
            setCart(data)




      //          fetch("https://km-main-back-update.vercel.app/config").then(async (r) => {
      // const { publishableKey } = await r.json();
      // setStripePromise(loadStripe("publishableKey"));
    // });


  fetch("https://km-main-back-update.vercel.app/AllCreateDisCountPrice",{
          method: "GET",
          headers :  {
          "Content-Type" : "application/json" , 
      } ,
      })
      .then(res7=>res7.json())
      .then(res8=>{
       setdiscount(res8)
       })
         

        
            fetch("https://paint-saudi-rayidh-main-back.vercel.app/AllUserCheckoutData",{
                method: "GET",
                 headers :  {
                 "Content-Type" : "application/json" , 
             } ,
            })
            .then(res181=>res181.json())
            .then(res191=>{
                // setNum1111(res191.length)
                let date = new Date()
                let day= date.getDate() 
                let month= (date.getUTCMonth()+1)
                let year= date.getUTCFullYear()
                if(date.getDate() < 10) day = "0"+ date.getDate()
                if(date.getUTCMonth()+1 < 10) month = "0"+ (date.getUTCMonth()+1)
                
                let c = day +""+month+ ""+(year -2000)
                const f = res191.filter((res,i)=>res.Date === c)
                console.log(f.length+1,c)
                setNum1111(f.length+2)
                setNum11(c)
            
            })
            // setot(JSON.parse(localStorage.getItem("CartPrice")) )
            // if(JSON.parse(localStorage.getItem("Custom Img")) )
            // setcustomPhotojson(true )

            // data.map((res,i)=>{
            //     if(res.Product_Catagories === "Custom Products"){
            //         setplay(true)
            //     }
            // })
            fetch("https://paint-saudi-rayidh-main-back.vercel.app/AllUserCheckoutData",{
                method: "GET",
                 headers :  {
                 "Content-Type" : "application/json" , 
             } ,
            })
            .then(res181=>res181.json())
            .then(res191=>{
                setNum1111(res191.length)
            })
          
  fetch("https://paint-saudi-rayidh-main-back.vercel.app/admindata",{
    method: "GET",
     headers :  {
     "Content-Type" : "application/json" , 
 } ,
})
.then(res18=>res18.json())
.then(res19=>{
    setdoctor(res19[0].condition)
    console.log(res19[0].DeliveryCharges,JSON.parse(localStorage.getItem("CartPrice")));
  setadmindataall(res19[0].DeliveryCharges)
console.log(res19[0].DeliveryCharges)
  let j = 0
  let k = 0
//   if(JSON.parse(localStorage.getItem("CartPrice")) < res19[0].condition){
                // j = res19[0].DeliveryCharges
            // }
            // else{
            //     j = 0
            // }
            data.map((item,i)=>{
               j = item.Total_Product_Price + j
               k = item.Pieces + k
            //    if (item.doctor_prescription){
            //     localStorage.setItem("doctor",JSON.stringify(true))
            //    }
            })
            setSubTotal(j)
            setSubPeice(k)
            // var doc =  JSON.parse(localStorage.getItem("doctor")) 
            // setdoctor(doc)

            if(JSON.parse(localStorage.getItem("discount")) && !JSON.parse(localStorage.getItem("discount")).discount2 ){
                setdiscount(JSON.parse(localStorage.getItem("discount")))
                var d = document.getElementById("discount")
                if(JSON.parse(localStorage.getItem("discount")).discount > 1){
                    d.innerHTML = " SAR.  <b style='font-size:20px'></b>" +JSON.parse(localStorage.getItem("discount")).discount
                    // document.getElementById("ci11").style.visibility = "visible"
                    j = j - parseInt(JSON.parse(localStorage.getItem("discount")).discount)
                }
                else{
                    d.innerHTML = " " +JSON.parse(localStorage.getItem("discount")).discount1 +" % Off"
                    j =j - (j*(JSON.parse(localStorage.getItem("discount")).discount1)/100)
                    
                }
            }else{
                var d = document.getElementById("discount")
                d.innerHTML = "No discount"
                
            }
            
            
            if(JSON.parse(localStorage.getItem("discount")) && JSON.parse(localStorage.getItem("discount")).discount2 ){
                setdiscount(JSON.parse(localStorage.getItem("discount")))
            var d = document.getElementById("discount")
           
            d.innerHTML = " " +JSON.parse(localStorage.getItem("discount")).discount2 +" % Off"
            j =j - (j*(JSON.parse(localStorage.getItem("discount")).discount2)/100)
            


                }

              j =  j+  res19[0].DeliveryCharges



            setot(j.toFixed(0))
            // var t = document.getElementById("subtotal")
            // t.innerHTML = "Rs "+j
            var f = document.getElementById("total")
            f.innerHTML = "SAR.  " +j.toFixed(0)

        })

        }
        // console.log(total,cart,j)
   else{
    swal("Cart Is Empty")
    props.history.push("/")
            // var t = document.getElementById("subtotal")
            // t.innerHTML = "Rs "+0
            var f = document.getElementById("total")
            f.innerHTML = "SAR. " +0
   }
  },[])
  

//   useEffect(() => {
  
//     return () => {
//         localStorage.removeItem("doctor")
//     }
//   }, [])

const setCouopon = () =>{
     
        // var d = document.getElementById("discount")
        // var d1 = document.getElementById("discount1")
        // const the = discount.filter((res,i)=> res.name === promo)
        // console.log(the)
        // if(the.length === 0){
        //   swal("Please enter a correct promo code");
        //   document.getElementById("grand-total").innerHTML = total1
        //   localStorage.removeItem("discount")
        //   return
        // }
        // if(the[0].discount === null &&the[0].discount1 === null){
        //   swal("Please enter a correct promo code");
        //   document.getElementById("grand-total").innerHTML = total1
        //   localStorage.removeItem("discount")
        //   return
          
        // }
        // if(the.length > 0){
      
        //   setdiscount6(the[0])
        //   if( the[0].discount > 1){
        //     settot((parseInt(total1) -parseInt(total1) * parseInt(the[0].discount))/100)
        //     // settotal1((total1 * the[0].discount1)/100)
        //     localStorage.setItem("discount",JSON.stringify(the[0]))
        //     // d.innerHTML = "Rs " +the[0].discount
        //     // d.innerHTML = "Discount : "
        //     swal("Update!","Successfully your Promo Applied ", "success");
            
        //   }
        //   else{
            
        //     console.log(total1 -(total1 * the[0].discount1)/100)
        //     settot((parseInt(total1) -(parseInt(total1) * parseInt(the[0].discount1))/100))
        //     // settotal1((total1 * the[0].discount1)/100)
        //     // console.log(total1 , (total1/the[0].discount1))
        //     localStorage.setItem("discount",JSON.stringify(the[0]))
        //     // d.innerHTML = " " +the[0].discount1 +" % Off"
        //     // d.innerHTML = "Discount : "
        //     swal("Update!","Successfully your Promo Applied ", "success");
      
        //   }
        // }
        // else{
        //   swal("Please enter a correct promo code");
        // }
          
        }

    // const SubmitDataMessage1 = () =>{
        // e.preventDefault()

    const SubmitDataMessage1 = (e) =>{
        e.preventDefault()
             console.log(cart,6787 ,customPhotojson, play,tot ,JSON.parse(localStorage.getItem("CartPrice"))-tot , JSON.parse(localStorage.getItem("CartPrice")))
      



            if (cart.length  >= 1 ){

              if(fname === ""){
                swal("Fill The Name");
                 return
             }
             if(Email === ""){
               setEmail("noemail@gmail.com")
              }
              if(Phone === ""){
                 swal("Fill The Phone");
                  return
              }
            
             if(Address === ""){
                swal("Fill The Address");
                 return
             }
             if(City === ""){
                swal("Fill The City");
                 return
             }

                setdisplay(false)
               let j
        if(admindataall > 0){
                 j = admindataall
            }
            else{
                 j = 0
            }
           
            let differnet = {
                DIFFERENTfname,
                DIFFERENTLname ,
                DIFFERENTAddress ,
                DIFFERENTAddress1 ,
                DIFFERENTZipPostal : 1111 ,
                DIFFERENTCity,
                DIFFERENTEmail ,
                DIFFERENTPhone ,
                DIFFERENTOrder_Notes,
            }
                
                console.log(differnet,                Num11," tfgrtg  ",Num1111,
                )



                let das = {}

                if(discount.discount){
                  if(discount.discount > 1)
                das= {
                  name : discount.discount ,
                  type : "R"
                }
                
                // else
                // t = t -  (t * (discount.discount1 / 100))
                
                }
                
                if(discount.discount1)
                das= {
                  name : discount.discount1 ,
                  type : "P"
                }
                
                
                // if(discount.discount2)
                // t = t -  (t * (discount.discount1 / 100))
                


// payment method here 












                    
                                fetch("https://paint-saudi-rayidh-main-back.vercel.app/UsergetDatafromclient",{
                        method: "POST",
                        headers :  {
                            "Content-Type" : "application/json" , 
                        } ,
                        body : JSON.stringify({
                            fname,
                            Lname ,
                            Address ,
                            Address1 ,
                            ZipPostal : 1111 ,
                            City,
                            Email ,
                            Das: das,
                            Phone ,
                            differnet ,
                            Order_Notes,
                            DeliveryCharges:j,
                            discount ,
                               AfterDiscount :  tot ,
                               LessAmount :  JSON.parse(localStorage.getItem("CartPrice"))-tot ,
                               TotalAmount  : JSON.parse(localStorage.getItem("CartPrice")) ,
                            
                            Order : cart,
                            Num123 : Num11+""+Num1111+1,
                        }),
                    })
                    .then(res=>res.json())
                    .then((res2)=>{        
                    if(!res2.Error){
                       
                        setdisplay(true)
                        makePayment()
                        swal("Order placed Successfully");
                       



                            setfName ("")
                            setLName ("" )
                            setAddress  ("")
                            setAddress1 ("" )
                            setZipPostal ("" )
                            setEmail ("" )
                            setCity ("" )
                            setPhone ("" )
                            setOrder_Notes ("")
                        localStorage.removeItem("Cart")
                        localStorage.removeItem("doctor")
                        localStorage.removeItem("SearchData")
                        localStorage.removeItem("Data")
                        localStorage.removeItem("CartPrice")
                        localStorage.removeItem("CateProduct")
                        localStorage.removeItem("discount")
                        localStorage.removeItem("Custom Img")
                        props.history.push(`/thankyou`)

                     }
                     else{
                      console.log("3")
                        setdisplay(true)
                        swal("Plz Refresh And try Again the Order");
                     }
                  })
                  .catch(err=>{
                    setdisplay(true)
                    swal("There is an Error");
                })









            }
           
            else{
                swal("There is No Any Product in Your Cart");
                setTimeout(()=>{
                    
                    props.history.push(`/`)
                },2000)
            }
        // })
        // }
       
    }
  
















    //   const makePayment = async()=>{
    //             console.log("fff")
    //     const stripe = await loadStripe("pk_live_51RSbkBKyDNhxfO0273lYRlDTckYPEXTKqL0xT8LLaGfhXyo8GL3R1n878yAobbFB9uR8gun4PkaASrHin5Jz5FK700VWvuyoBk");

    //     const body = {
    //         products:cart
    //     }


    //     const headers = {
    //                         "Content-Type" : "application/json" , 
    //     }
    //     const response = await fetch("https://paint-saudi-rayidh-main-back.vercel.app/create-checkout-session",{
    //         method:"POST",
    //         headers:headers,
    //         body:JSON.stringify(body)
    //     });

    //     const session = await response.json();

    //     const result = stripe.redirectToCheckout({
    //         sessionId:session.id
    //     });
        
    //     if(result.error){
    //         console.log(result.error);
    //     }






    

    // }






















    return (
      <div className="page-wrapper">
      
   <main className="main">
       
<nav aria-label="breadcrumb" className="breadcrumb-nav">
  <div className="container">
    <ol className="breadcrumb">
      <li className="breadcrumb-item"><Link to="/">الرئيسية</Link></li>
      <li className="breadcrumb-item active" aria-current="page"  style={{color :  "rgb(163, 209, 51)",fontWeight:"bold"}}>الدفع</li>
    </ol>
  </div>
</nav>

<div className="page-content">
  <div className="checkout">
    <div className="container">

      <div className="checkout-discount">
        <form action="#">
          <input type="text" className="form-control" required id="checkout-discount-input" />
          <label  style={{textAlign:"right"}} htmlFor="checkout-discount-input" className="text-truncate">
            هل لديك قسيمة خصم؟ <Link to="/cart"><span>اضغط هنا لإدخال الرمز</span></Link>
          </label>
        </form>
      </div>

      <form onSubmit={(e)=>SubmitDataMessage1(e)}>

        <div className="row">
          <div className="col-lg-9">
            <h2 className="checkout-title" style={{textAlign:"right"}}>تفاصيل الفاتورة</h2>

            <div className="row">
              <div className="col-sm-12">
                <label  style={{textAlign:"right"}}>الاسم الكامل *</label>
                <input type="text" className="form-control" required value={fname} onChange={(e)=>setfName(e.target.value)} placeholder="ادخل الاسم الكامل"/>
              </div>
            </div>

            <label  style={{textAlign:"right"}}>عنوان الشارع *</label>
            <input type="text" className="form-control" required placeholder="ادخل العنوان مع رقم المنزل، الحي والمدينة" value={Address} onChange={(e)=>setAddress(e.target.value)} />

            <div className="row">
              <div className="col-sm-12">
                <label  style={{textAlign:"right"}}>المدينة *</label>
                <input type="text" className="form-control" required placeholder="ادخل المدينة" value={City} onChange={(e)=>setCity(e.target.value)}/>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <label  style={{textAlign:"right"}}>رقم الجوال *</label>
                <input type="tel" className="form-control" placeholder="ادخل رقم الجوال" required value={Phone} onChange={(e)=>setPhone(e.target.value)} />
              </div>
            </div>

            <label  style={{textAlign:"right"}}>البريد الإلكتروني *</label>
            <input type="email" className="form-control" placeholder="ادخل البريد الإلكتروني" required value={Email} onChange={(e)=>setEmail(e.target.value)} />

            <label  style={{textAlign:"right"}}>ملاحظات الطلب (اختياري)</label>
            <textarea className="form-control" cols={30} rows={4} placeholder="ملاحظات حول طلبك، مثل تعليمات خاصة للتوصيل" defaultValue={""}  value={Order_Notes} onChange={(e)=>setOrder_Notes(e.target.value)} />
          
          </div>

          <aside className="col-lg-3">
            <div className="summary">
              <h3 className="summary-title" style={{textAlign:"right"}}>تفاصيل الطلب</h3>

              <table className="table table-summary table-summary1">
                <thead>
                  <tr>
                    <th style={{fontWeight:"600",color:"black"}}>المنتج</th>
                    <th style={{fontWeight:"600",color:"black"}}>الكمية</th>
                    <th style={{fontWeight:"600",color:"black"}}>الإجمالي</th>
                  </tr>
                </thead>

                <tbody>

                {
                  cart && cart.map((item,i)=>{
                    if(item.Price[0]){
                      return(
                        <tr>
                          <td><a>{item.Product_Name}</a>  
                            <span style={{paddingLeft:"30px"}}>
                              {item.Size.length > 2 ? "اللون : " : "المقاس : "} {item.Size}
                            </span>
                          </td>
                          <th>x {item.Pieces}</th>
                          <td>SAR. {(item.Total_Product_Price).toFixed(0)}</td>
                        </tr>
                      )
                    }
                    else{
                      return(
                        <tr>
                          <div style={{maxWidth:"90%",maxHeight:"76px",overflow:"hidden"}}>
                            <td style={{textAlign:"left"}}>
                              {item.Product_Name}
                            </td>
                          </div>
                          <th>x {item.Pieces}</th>
                          <td>SAR. {(item.Total_Product_Price).toFixed(0)}</td>
                        </tr>
                      )
                    }
                  })
                }

                <tr className="summary-subtotal sub-total-border">
                  <td>المجموع . {SubPeice} منتجات</td>
                  <td></td>
                  <td>SAR. {SubTotal}</td>
                </tr>

                <tr className="summary-subtotal sub-total-border">
                  <td>الشحن</td>
                  <td></td>
                  <td>
                    { admindataall > 0 ? "SAR. "+admindataall : <b>25</b> }
                  </td>
                </tr>

                {JSON.parse(localStorage.getItem("discount")) ?
                  <tr className="summary-subtotal sub-total-border">
                    <td>الخصم</td>
                    <td></td>
                    <td id="discount"></td>
                  </tr>
                : ""}

                <tr className="summary-total">
                  <td style={{fontWeight:"bold",fontSize:"1.7rem"}}>الإجمالي</td>
                  <td></td>
                  <td style={{fontWeight:"bold",fontSize:"1.7rem"}} id="total">SAR. </td>
                </tr>

              </tbody>
              </table>

              <div className="accordion-summary" id="accordion-payment">
                <div className="card">
                  <div className="card-header" id="heading-3">
                    <h2 className="card-title">
                      <input type="radio" id="" checked value={true} style={{marginRight:"10px"}}/>
                      الدفع عند الاستلام
                    </h2>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-outline-primary-2 btn-order btn-block uihuihiuh" style={{padding:"14px 38px",background:"#008071",color:"white",fontSize:"large"}}>
                <span style={{fontSize:"large"}}>تأكيد الطلب</span>
              </button>

            </div>
          </aside>
        </div>
      </form>

    </div>
    <td id="discount" style={{color:"white",display:"none"}}></td>
  </div>
</div>

</main>

    </div>
        )
    
}

export default Checkout;